import { AvailabilityEvent } from "@/modules/Availability/models/AvailabilityEventModel";

export class PartialCampus {
  id = "";
  address = "";
  name = "";
}

export class PartialPatient {
  id = "";
  name = "";
  document = "";
}

export class PartialService {
  id = "";
  state = "";
  category = "";
  type = "";
  name = "";
}

export class PartialAvailability {
  id = "";
}

// This class is used to describe the information about an appointment inside the Doctor agenda
export class AppointmentResponse {
  medicalAppointmentList!: AppointmentItem[];
  unbookedEventsList!: {
    ok: boolean;
    events: {
      [key: string]: AvailabilityEvent[];
    };
  };
}
export class AppointmentItem {
  id = "";
  start!: number;
  end!: number;
  name!: string;
  eventKey?: string;
  doctor?: string[];
  patient: PartialPatient = new PartialPatient();
  service: PartialService = new PartialService();
  campus: PartialCampus = new PartialCampus();
  availability: PartialAvailability = new PartialAvailability();
  state!: string;
  color!: string;
}
